
















import {Prop, Component, Watch, Model, Vue} from 'vue-property-decorator';
import {SimpleFileField, MediaFileField} from '@/models/fields';
import {BusEvent} from '@/models/bus';

@Component
export default class DropDownEntity extends Vue {
    @Model('update', {type: String, default: ''}) public text!: string;
    @Prop({type: String}) public placeholder!: string;
    @Prop() public options!: string[];
    @Prop() public presentation!: string[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public optionsList: object[] = null;
    public selectedText: string = null;

    public beforeMount() {
        this.loadOptions();
    }

    @Watch('options')
    public loadOptions() {
        if (this.options) {
            this.optionsList = [];
            for (const i of Object.keys(this.options)) {
                this.optionsList.push({ key: this.options[i], value: this.options[i], text: this.presentation[i]});
            }
            this.selectedText = this.text;
        }
    }

    @Watch('selectedText')
    public updateText() {
        this.$emit('update', this.selectedText);
    }

    @Watch('text')
    public updateSelectedText() {
        this.selectedText = this.text;
    }
}

